import * as React from "react";
import { useState, useEffect } from "react";

const XeokitViewer = ({
  display3D,
  showCube,
  cubeIsInitialized,
  largeWidth = false,
}) => {
  const [show, setShow] = useState(false);

  useEffect(() => {
    setTimeout(() => setShow(showCube), showCube ? 2000 : 100);
  }, [showCube]);

  return (
    <>
      <canvas
        id="xeokitCanvas"
        style={{
          position: "absolute",
          top: 0,
          left: 0,
          background: "lightblue",
          backgroundImage: "linear-gradient(lightblue, white)",
          width: largeWidth
            ? "calc(100vw - 290px)"
            : "calc(100vw - 290px - 250px)",
          height: "calc(100vh - 64px)",
          overflow: "hidden!important",
          visibility: display3D,
        }}
      ></canvas>
      <canvas
        id="myNavCubeCanvas"
        style={{
          position: "absolute",
          width: "200px",
          height: "200px",
          bottom: "30px",
          right: "50px",
          zIndex: 1000,
          overflow: "hidden!important",
          visibility: show ? "visible" : "hidden",
          display: show ? "unset" : "none",
        }}
      ></canvas>
      <canvas
        id="mySectionPlanesOverviewCanvas"
        style={{
          position: "absolute",
          width: "-200px",
          height: "200px",
          bottom: "30px",
          right: "50px",
          zIndex: 1000,
          visibility: show ? "visible" : "hidden",
          display: show ? "unset" : "none",
        }}
      ></canvas>
      <div
        id="distanceMeasurementContainer"
        style={{
          position: "absolute",
          zIndex: 0,
          display: display3D === "hidden" ? "none" : "block",
        }}
      ></div>
    </>
  );
};

export default XeokitViewer;



// WEBPACK FOOTER //
// ./src/modules/WBS/components/layouts/XeokitViewer.tsx